import { render, staticRenderFns } from "./ManageBalanceSteps.vue?vue&type=template&id=90d586d2&scoped=true&"
import script from "./ManageBalanceSteps.vue?vue&type=script&lang=js&"
export * from "./ManageBalanceSteps.vue?vue&type=script&lang=js&"
import style0 from "./ManageBalanceSteps.vue?vue&type=style&index=0&id=90d586d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d586d2",
  null
  
)

export default component.exports